import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useParams } from "react-router-dom";

const Header =({title, to, onExcel}) => {
    const { t } = useTranslation();
    const { id: clubId } = useParams();

    return (
        <div className={`clubSection`}>
            {onExcel ?
                (<span className="dialogHeaderExcel" onClick={onExcel}></span>) :
                false
            }
            {t(`clubItems.${title}`)}
            <span className={`clubId`}>{t('clubId')}: {clubId}</span>
            <NavLink to={to} className={`closeIcon`} >
                <i className=" fa close-icon fa-times " />
            </NavLink>
        </div>
    );
};

export default Header;
